var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11716 12.6172C6.27337 12.4609 6.52663 12.4609 6.68284 12.6172L9.6 15.5343L12.5172 12.6172C12.6734 12.4609 12.9266 12.4609 13.0828 12.6172C13.2391 12.7734 13.2391 13.0266 13.0828 13.1828L9.88284 16.3828C9.80783 16.4579 9.70609 16.5 9.6 16.5C9.49391 16.5 9.39217 16.4579 9.31716 16.3828L6.11716 13.1828C5.96095 13.0266 5.96095 12.7734 6.11716 12.6172Z",
    fill: "#8A8C8E",
    stroke: "#8A8C8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8828 7.63284C12.7266 7.78905 12.4734 7.78905 12.3172 7.63284L9.4 4.71569L6.48284 7.63284C6.32663 7.78905 6.07337 7.78905 5.91716 7.63284C5.76095 7.47663 5.76095 7.22337 5.91716 7.06716L9.11716 3.86716C9.19217 3.79214 9.29391 3.75 9.4 3.75C9.50609 3.75 9.60783 3.79214 9.68284 3.86716L12.8828 7.06716C13.0391 7.22337 13.0391 7.47663 12.8828 7.63284Z",
    fill: "#8A8C8E",
    stroke: "#8A8C8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sort-by.3e2d0e65f0452f3cc103824d6bc664ba.svg";
export { ForwardRef as ReactComponent };